import { BFF_HARDENING_KEY, HARNESS_FLAGS } from './harnessFlags';
import useHarnessFlag from './useHarnessFlag';

// ECDEX-1567 global switch. isResolved stays false until the SDK is ready or
// times out, so callers that must not act on the default can wait for it.
const useBffHardening = () => {
  const { enabled, isResolved } = useHarnessFlag({
    flagKey: HARNESS_FLAGS.BFF_HARDENING,
    splitKey: BFF_HARDENING_KEY,
  });
  return { enabled, isResolved };
};

export default useBffHardening;
